// pages/UploadCSV/index.tsx
import React, { useState } from 'react';

import { UploadCSVFormProvider } from '../../context/UploadCSVFormProvider';
import { UploadCSVBanner, UploadCSVForm } from '../../components/UploadCSV';
import { Notification } from '@flixbus/honeycomb-react';
import styles from './upload-csv.module.scss';
import { useGlobalNotificationPortal } from '../../hooks/useGlobalNotificationPortal';

const UploadCSV = () => {
  const [showNotification, setShowNotification] = useState(true);
  const { Portal } = useGlobalNotificationPortal();

  function closeNotification() {
    setShowNotification(false);
  }

  return (
    <UploadCSVFormProvider>
      {showNotification && (
        <Portal>
          <Notification
            appearance='warning'
            closeProps={{ 'aria-label': 'Close', onClick: closeNotification }}
          >
            CSV uploads can only be used to <span className={styles.Warning}>DISABLE</span> vouchers
            — creation and updates are not supported at the moment.
          </Notification>
        </Portal>
      )}

      <UploadCSVBanner title='Upload CSV file' subHeader='Voucher Disabling' />
      <UploadCSVForm />
    </UploadCSVFormProvider>
  );
};

export default UploadCSV;
